const ENABLED_COUNTRIES = ['CA', 'IN', 'MX', 'PH', 'ID', 'PE', 'CO', 'BR'];

export const hasMonthlyBillingEnabled = (
  country: string | null | undefined,
) => {
  return Boolean(country && ENABLED_COUNTRIES.includes(country));
};
